
export const productRenderFields = [
  { key: 'name', descriptor: 'Product Name', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Product name can only contain letters, numbers, and spaces.' },
  { key: 'description', descriptor: 'Description', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Description can only contain letters, numbers, spaces, commas, and periods.' },
  { key: 'market_size', descriptor: 'Market Size', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'Market size should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
  { key: 'revenue_model', descriptor: 'Revenue Model', inputType: 'select', options: ['Subscription Model', 'Sales Model'] },
  { key: 'annual_price', descriptor: 'Annual Price', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'Annual price should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
  { key: 'market_capture', descriptor: 'Market Capture %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Market capture should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'revenue_allocation', descriptor: 'Revenue Allocation %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Revenue Allocation % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'churn_rate', descriptor: 'Churn Rate %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Churn rate should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'growth_rate', descriptor: 'Growth Rate %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Growth rate should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'growth_adjustment', descriptor: 'Growth Adjustment %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Growth adjustment should be a number with up to 2 decimal places.', default: "0.00" },
];

/*

 { key: 'sales_marketing_of_revenue', descriptor: 'Sales & Marketing % of Revenue', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Sales & Marketing % of Revenue should be a number with up to 2 decimal places.', default: "0.00" },
    { key: 'adjust_for_eff_and_automation', descriptor: 'Adjust for Efficiency & Automation %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Adjust for Efficiency & Automation % should be a number with up to 2 decimal places.', default: "0.00" }

*/

export const currencyOptions = [
  "USD", "AUD", "BRL", "CAD", "CNY", "DKK", "EUR", "HKD", "INR",
  "JPY", "MYR", "MXN", "NZD", "NOK", "SGD", "ZAR", "KRW", "LKR",
  "SEK", "CHF", "TWD", "THB", "GBP"
];

export const currencySymbols = {
  "USD": "$",
  "AUD": "$",
  "BRL": "R$",
  "CAD": "$",
  "CNY": "¥",
  "DKK": "kr",
  "EUR": "€",
  "HKD": "$",
  "INR": "₹",
  "JPY": "¥",
  "MYR": "RM",
  "MXN": "$",
  "NZD": "$",
  "NOK": "kr",
  "SGD": "$",
  "ZAR": "R",
  "KRW": "₩",
  "LKR": "Rs",
  "SEK": "kr",
  "CHF": "CHF",
  "TWD": "NT$",
  "THB": "฿",
  "GBP": "£",
  "VEF": "Bs"
};

export const industryOptions = [
  "SaaS (Software as a Service)",
  "AI & Machine Learning",
  "Cybersecurity",
  "Fintech",
  "Blockchain & Web3",
  "HealthTech",
  "Biotech",
  "Mental Health & Wellness",
  "Fitness Tech",
  "Ecommerce",
  "DTC (Direct-to-Consumer)",
  "FoodTech",
  "FashionTech",
  "CleanTech",
  "AgriTech",
  "ClimateTech",
  "Transportation & Mobility",
  "Logistics & Supply Chain",
  "Smart Cities & IoT",
  "EdTech",
  "HRTech & Future of Work",
  "PropTech",
  "TravelTech",
  "Home & Living",
  "Gaming & Esports",
]

const beginning_cash = [
  3000000,
  4250000,
  3750000,
  3250000,
  2750000,
  3750000,
  5000000,
  2500000,
  2000000,
  2000000,
  2000000,
  2500000,
  2000000,
  4000000,
  3250000,
  4500000,
  4000000,
  3250000,
  3250000,
  2000000,
  2500000,
  2750000,
  2000000,
  2000000,
  2750000,
]

export const industryDetails = {
  "SaaS (Software as a Service)": {
    "theme": "Technology & Software",
    "details": "Cloud-based software solutions for businesses.",
    "labor_cost": 0.5,
    "avg_salary": 130000,
    "cor_product_dev": 0.5,
    "cor_gto_and_operational": 0.3,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 27.2,
    "firm_cor": 0.31,
    "cor_product_dev_eff": 0.675,
    "cor_gto_and_operational_eff": 0.675,
    "cor_infrast_and_admin_eff": 0.675,
    "cogs_product_dev": 0.41,
    "cogs_gto_and_operational": 0.05,
    "cogs_infrast_and_admin": 0.1,
    "default_growth_rate": 0.87,
    "default_growth_adjustment": 0.624,
    "beginning_cash": beginning_cash[0],
    "investment_amount": beginning_cash[0],
    "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "AI & Machine Learning": {
    "theme": "Technology & Software",
    "details": "Tools and platforms using artificial intelligence.",
    "labor_cost": 0.55,
    "avg_salary": 160000,
    "cor_product_dev": 0.6,
    "cor_gto_and_operational": 0.25,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 50,
    "firm_cor": 0.42,
    "cor_product_dev_eff": 0.63,
    "cor_gto_and_operational_eff": 0.63,
    "cor_infrast_and_admin_eff": 0.63,
    "cogs_product_dev": 0.59,
    "cogs_gto_and_operational": 0.05,
    "cogs_infrast_and_admin": 0.2,
    "default_growth_rate": 1.8,
    "default_growth_adjustment": 0.69,
    "beginning_cash": beginning_cash[1],
    "investment_amount": beginning_cash[1],
    "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "Cybersecurity": {
    "theme": "Technology & Software",
    "details": "Protecting digital assets and data.",
    "labor_cost": 0.5,
    "avg_salary": 145000,
    "cor_product_dev": 0.55,
    "cor_gto_and_operational": 0.25,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 28.3,
    "firm_cor": 0.38,
    "cor_product_dev_eff": 0.58,
    "cor_gto_and_operational_eff": 0.58,
    "cor_infrast_and_admin_eff": 0.58,
    "cogs_product_dev": 0.4,
    "cogs_gto_and_operational": 0.05,
    "cogs_infrast_and_admin": 0.05,
    "default_growth_rate": 1.19,
    "default_growth_adjustment": 0.67,
    "beginning_cash": beginning_cash[2],
    "investment_amount": beginning_cash[2], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "Fintech": {
    "theme": "Technology & Software",
    "details": "Financial technology (e.g., digital banking, payments, crypto).",
    "labor_cost": 0.5,
    "avg_salary": 137500,
    "cor_product_dev": 0.45,
    "cor_gto_and_operational": 0.3,
    "cor_infrast_and_admin": 0.25,
    "pe_ratio": 27.4,
    "firm_cor": 0.55,
    "cor_product_dev_eff": 0.6,
    "cor_gto_and_operational_eff": 0.6,
    "cor_infrast_and_admin_eff": 0.6,
    "cogs_product_dev": 0.75,
    "cogs_gto_and_operational": 0.07,
    "cogs_infrast_and_admin": 0.16,
    "default_growth_rate": 1.65,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[3],
    "investment_amount": beginning_cash[3], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "Blockchain & Web3": {
    "theme": "Technology & Software",
    "details": "Decentralized apps, NFTs, and smart contracts.",
    "labor_cost": 0.4,
    "avg_salary": 135000,
    "cor_product_dev": 0.5,
    "cor_gto_and_operational": 0.3,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 32.8,
    "firm_cor": 0.45,
    "cor_product_dev_eff": 0.5,
    "cor_gto_and_operational_eff": 0.5,
    "cor_infrast_and_admin_eff": 0.5,
    "cogs_product_dev": 0.59,
    "cogs_gto_and_operational": 0.07,
    "cogs_infrast_and_admin": 0.1,
    "default_growth_rate": 2.28,
    "default_growth_adjustment": 0.64,
    "beginning_cash": beginning_cash[4],
    "investment_amount": beginning_cash[4], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "HealthTech": {
    "theme": "Health & Wellness",
    "details": "Digital health platforms, telemedicine, and diagnostics.",
    "labor_cost": 0.45,
    "avg_salary": 127500,
    "cor_product_dev": 0.5,
    "cor_gto_and_operational": 0.3,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 26.1,
    "firm_cor": 0.53,
    "cor_product_dev_eff": 0.55,
    "cor_gto_and_operational_eff": 0.55,
    "cor_infrast_and_admin_eff": 0.55,
    "cogs_product_dev": 0.63,
    "cogs_gto_and_operational": 0.08,
    "cogs_infrast_and_admin": 0.1,
    "default_growth_rate": 1.55,
    "default_growth_adjustment": 0.55,
    "beginning_cash": beginning_cash[5],
    "investment_amount": beginning_cash[5], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "Biotech": {
    "theme": "Health & Wellness",
    "details": "Drug development, genomics, and medical research.",
    "labor_cost": 0.33,
    "avg_salary": 122500,
    "cor_product_dev": 0.7,
    "cor_gto_and_operational": 0.15,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 21.6,
    "firm_cor": 0.87,
    "cor_product_dev_eff": 0.3,
    "cor_gto_and_operational_eff": 0.3,
    "cor_infrast_and_admin_eff": 0.3,
    "cogs_product_dev": 0.34,
    "cogs_gto_and_operational": 0.02,
    "cogs_infrast_and_admin": 0.04,
    "default_growth_rate": 0.79,
    "default_growth_adjustment": 0.68,
    "beginning_cash": beginning_cash[6],
    "investment_amount": beginning_cash[6], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "Mental Health & Wellness": {
    "theme": "Health & Wellness",
    "details": "Therapy apps, mindfulness, and self-care tools.",
    "labor_cost": 0.6,
    "avg_salary": 105000,
    "cor_product_dev": 0.4,
    "cor_gto_and_operational": 0.4,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 20,
    "firm_cor": 0.62,
    "cor_product_dev_eff": 0.58,
    "cor_gto_and_operational_eff": 0.58,
    "cor_infrast_and_admin_eff": 0.58,
    "cogs_product_dev": 0.9,
    "cogs_gto_and_operational": 0.11,
    "cogs_infrast_and_admin": 0.2,
    "default_growth_rate": 1.13,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[7],
    "investment_amount": beginning_cash[7], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "Fitness Tech": {
    "theme": "Health & Wellness",
    "details": "Wearables, fitness apps, and connected equipment.",
    "labor_cost": 0.4,
    "avg_salary": 110000,
    "cor_product_dev": 0.45,
    "cor_gto_and_operational": 0.35,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 23,
    "firm_cor": 0.64,
    "cor_product_dev_eff": 0.63,
    "cor_gto_and_operational_eff": 0.63,
    "cor_infrast_and_admin_eff": 0.63,
    "cogs_product_dev": 0.86,
    "cogs_gto_and_operational": 0.1,
    "cogs_infrast_and_admin": 0.2,
    "default_growth_rate": 1.54,
    "default_growth_adjustment": 0.55,
    "beginning_cash": beginning_cash[8],
    "investment_amount": beginning_cash[8], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1,
  },
  "Ecommerce": {
    "theme": "Consumer & Commerce",
    "details": "Online retail platforms and marketplaces.",
    "labor_cost": 0.23,
    "avg_salary": 115000,
    "cor_product_dev": 0.3,
    "cor_gto_and_operational": 0.5,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 28.1,
    "firm_cor": 0.93,
    "cor_product_dev_eff": 0.5,
    "cor_gto_and_operational_eff": 0.5,
    "cor_infrast_and_admin_eff": 0.5,
    "cogs_product_dev": 0.84,
    "cogs_gto_and_operational": 0.4,
    "cogs_infrast_and_admin": 0.2,
    "default_growth_rate": 2.49,
    "default_growth_adjustment": 0.53,
    "beginning_cash": beginning_cash[9],
    "investment_amount": beginning_cash[9], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "DTC (Direct-to-Consumer)": {
    "theme": "Consumer & Commerce",
    "details": "Brands selling directly to customers online.",
    "labor_cost": 0.28,
    "avg_salary": 110000,
    "cor_product_dev": 0.25,
    "cor_gto_and_operational": 0.55,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 17,
    "firm_cor": 0.95,
    "cor_product_dev_eff": 0.45,
    "cor_gto_and_operational_eff": 0.45,
    "cor_infrast_and_admin_eff": 0.45,
    "cogs_product_dev": 0.84,
    "cogs_gto_and_operational": 0.4,
    "cogs_infrast_and_admin": 0.6,
    "default_growth_rate": 1.68,
    "default_growth_adjustment": 0.63,
    "beginning_cash": beginning_cash[10],
    "investment_amount": beginning_cash[10], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "FoodTech": {
    "theme": "Consumer & Commerce",
    "details": "Meal delivery, alternative proteins, and smart kitchens.",
    "labor_cost": 0.33,
    "avg_salary": 105000,
    "cor_product_dev": 0.4,
    "cor_gto_and_operational": 0.4,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 23.5,
    "firm_cor": 0.98,
    "cor_product_dev_eff": 0.4,
    "cor_gto_and_operational_eff": 0.4,
    "cor_infrast_and_admin_eff": 0.4,
    "cogs_product_dev": 0.9,
    "cogs_gto_and_operational": 0.46,
    "cogs_infrast_and_admin": 0.7,
    "default_growth_rate": 1.54,
    "default_growth_adjustment": 0.55,
    "beginning_cash": beginning_cash[11],
    "investment_amount": beginning_cash[11], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "FashionTech": {
    "theme": "Consumer & Commerce",
    "details": "Digital fashion, sustainable clothing, and virtual try-ons.",
    "labor_cost": 0.28,
    "avg_salary": 100000,
    "cor_product_dev": 0.35,
    "cor_gto_and_operational": 0.45,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 16.7,
    "firm_cor": 0.89,
    "cor_product_dev_eff": 0.45,
    "cor_gto_and_operational_eff": 0.45,
    "cor_infrast_and_admin_eff": 0.45,
    "cogs_product_dev": 0.8,
    "cogs_gto_and_operational": 0.32,
    "cogs_infrast_and_admin": 0.5,
    "default_growth_rate": 1.13,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[12],
    "investment_amount": beginning_cash[12], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "CleanTech": {
    "theme": "Sustainability & Environment",
    "details": "Renewable energy, carbon capture, and green tech.",
    "labor_cost": 0.35,
    "avg_salary": 120000,
    "cor_product_dev": 0.6,
    "cor_gto_and_operational": 0.25,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 24.4,
    "firm_cor": 0.65,
    "cor_product_dev_eff": 0.35,
    "cor_gto_and_operational_eff": 0.35,
    "cor_infrast_and_admin_eff": 0.35,
    "cogs_product_dev": 0.91,
    "cogs_gto_and_operational": 0.4,
    "cogs_infrast_and_admin": 0.6,
    "default_growth_rate": 1.13,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[13],
    "investment_amount": beginning_cash[13], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "AgriTech": {
    "theme": "Sustainability & Environment",
    "details": "Smart farming, vertical agriculture, and food sustainability.",
    "labor_cost": 0.3,
    "avg_salary": 107500,
    "cor_product_dev": 0.55,
    "cor_gto_and_operational": 0.3,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 15.7,
    "firm_cor": 0.77,
    "cor_product_dev_eff": 0.4,
    "cor_gto_and_operational_eff": 0.4,
    "cor_infrast_and_admin_eff": 0.4,
    "cogs_product_dev": 0.85,
    "cogs_gto_and_operational": 0.32,
    "cogs_infrast_and_admin": 0.6,
    "default_growth_rate": 0.79,
    "default_growth_adjustment": 0.68,
    "beginning_cash": beginning_cash[14],
    "investment_amount": beginning_cash[14], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "ClimateTech": {
    "theme": "Sustainability & Environment",
    "details": "Startups tackling climate change and emissions.",
    "labor_cost": 0.4,
    "avg_salary": 125000,
    "cor_product_dev": 0.65,
    "cor_gto_and_operational": 0.2,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 30.3,
    "firm_cor": 0.65,
    "cor_product_dev_eff": 0.35,
    "cor_gto_and_operational_eff": 0.35,
    "cor_infrast_and_admin_eff": 0.35,
    "cogs_product_dev": 0.85,
    "cogs_gto_and_operational": 0.32,
    "cogs_infrast_and_admin": 0.6,
    "default_growth_rate": 1.48,
    "default_growth_adjustment": 0.51,
    "beginning_cash": beginning_cash[15],
    "investment_amount": beginning_cash[15], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "Transportation & Mobility": {
    "theme": "Mobility & Infrastructure",
    "details": "EVs, ride-sharing, and micro-mobility.",
    "labor_cost": 0.28,
    "avg_salary": 115000,
    "cor_product_dev": 0.6,
    "cor_gto_and_operational": 0.25,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 23.4,
    "firm_cor": 0.92,
    "cor_product_dev_eff": 0.43,
    "cor_gto_and_operational_eff": 0.43,
    "cor_infrast_and_admin_eff": 0.43,
    "cogs_product_dev": 0.83,
    "cogs_gto_and_operational": 0.31,
    "cogs_infrast_and_admin": 0.6,
    "default_growth_rate": 1.65,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[16],
    "investment_amount": beginning_cash[16], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "Logistics & Supply Chain": {
    "theme": "Mobility & Infrastructure",
    "details": "Delivery optimization and freight tech.",
    "labor_cost": 0.23,
    "avg_salary": 110000,
    "cor_product_dev": 0.5,
    "cor_gto_and_operational": 0.3,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 22,
    "firm_cor": 0.98,
    "cor_product_dev_eff": 0.5,
    "cor_gto_and_operational_eff": 0.5,
    "cor_infrast_and_admin_eff": 0.5,
    "cogs_product_dev": 0.9,
    "cogs_gto_and_operational": 0.35,
    "cogs_infrast_and_admin": 0.65,
    "default_growth_rate": 1.13,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[17],
    "investment_amount": beginning_cash[17], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "Smart Cities & IoT": {
    "theme": "Mobility & Infrastructure",
    "details": "Connected infrastructure and urban tech.",
    "labor_cost": 0.4,
    "avg_salary": 125000,
    "cor_product_dev": 0.6,
    "cor_gto_and_operational": 0.25,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 28.3,
    "firm_cor": 0.69,
    "cor_product_dev_eff": 0.45,
    "cor_gto_and_operational_eff": 0.45,
    "cor_infrast_and_admin_eff": 0.45,
    "cogs_product_dev": 0.8,
    "cogs_gto_and_operational": 0.28,
    "cogs_infrast_and_admin": 0.5,
    "default_growth_rate": 1.54,
    "default_growth_adjustment": 0.55,
    "beginning_cash": beginning_cash[18],
    "investment_amount": beginning_cash[18], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "EdTech": {
    "theme": "Education & Work",
    "details": "Online learning, tutoring platforms, and skill development.",
    "labor_cost": 0.45,
    "avg_salary": 102500,
    "cor_product_dev": 0.45,
    "cor_gto_and_operational": 0.35,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 20.4,
    "firm_cor": 0.48,
    "cor_product_dev_eff": 0.6,
    "cor_gto_and_operational_eff": 0.6,
    "cor_infrast_and_admin_eff": 0.6,
    "cogs_product_dev": 0.6,
    "cogs_gto_and_operational": 0.05,
    "cogs_infrast_and_admin": 0.3,
    "default_growth_rate": 1.54,
    "default_growth_adjustment": 0.55,
    "beginning_cash": beginning_cash[19],
    "investment_amount": beginning_cash[19], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "HRTech & Future of Work": {
    "theme": "Education & Work",
    "details": "Hiring platforms, remote work tools, and productivity apps.",
    "labor_cost": 0.5,
    "avg_salary": 107500,
    "cor_product_dev": 0.6,
    "cor_gto_and_operational": 0.25,
    "cor_infrast_and_admin": 0.15,
    "pe_ratio": 27.2,
    "firm_cor": 0.39,
    "cor_product_dev_eff": 0.63,
    "cor_gto_and_operational_eff": 0.63,
    "cor_infrast_and_admin_eff": 0.63,
    "cogs_product_dev": 0.53,
    "cogs_gto_and_operational": 0.05,
    "cogs_infrast_and_admin": 0.25,
    "default_growth_rate": 1.41,
    "default_growth_adjustment": 0.46,
    "beginning_cash": beginning_cash[20],
    "investment_amount": beginning_cash[20], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "PropTech": {
    "theme": "Lifestyle & Real Estate",
    "details": "Real estate platforms, smart homes, and rental tech.",
    "labor_cost": 0.35,
    "avg_salary": 115000,
    "cor_product_dev": 0.45,
    "cor_gto_and_operational": 0.35,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 38.7,
    "firm_cor": 0.52,
    "cor_product_dev_eff": 0.5,
    "cor_gto_and_operational_eff": 0.5,
    "cor_infrast_and_admin_eff": 0.5,
    "cogs_product_dev": 0.82,
    "cogs_gto_and_operational": 0.13,
    "cogs_infrast_and_admin": 0.42,
    "default_growth_rate": 1.13,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[21],
    "investment_amount": beginning_cash[21], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "TravelTech": {
    "theme": "Lifestyle & Real Estate",
    "details": "Booking platforms, travel planning, and experiences.",
    "labor_cost": 0.33,
    "avg_salary": 102500,
    "cor_product_dev": 0.4,
    "cor_gto_and_operational": 0.4,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 23.4,
    "firm_cor": 0.67,
    "cor_product_dev_eff": 0.55,
    "cor_gto_and_operational_eff": 0.55,
    "cor_infrast_and_admin_eff": 0.55,
    "cogs_product_dev": 0.87,
    "cogs_gto_and_operational": 0.2,
    "cogs_infrast_and_admin": 0.45,
    "default_growth_rate": 1.54,
    "default_growth_adjustment": 0.55,
    "beginning_cash": beginning_cash[22],
    "investment_amount": beginning_cash[22], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "Home & Living": {
    "theme": "Lifestyle & Real Estate",
    "details": "Smart appliances, home improvement, and interior tech.",
    "labor_cost": 0.28,
    "avg_salary": 97500,
    "cor_product_dev": 0.35,
    "cor_gto_and_operational": 0.45,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 28.3,
    "firm_cor": 0.89,
    "cor_product_dev_eff": 0.45,
    "cor_gto_and_operational_eff": 0.45,
    "cor_infrast_and_admin_eff": 0.45,
    "cogs_product_dev": 0.9,
    "cogs_gto_and_operational": 0.36,
    "cogs_infrast_and_admin": 0.55,
    "default_growth_rate": 1.13,
    "default_growth_adjustment": 0.61,
    "beginning_cash": beginning_cash[23],
    "investment_amount": beginning_cash[23], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  },
  "Gaming & Esports": {
    "theme": "Entertainment & Media",
    "details": "Game development, streaming, and virtual worlds.",
    "labor_cost": 0.4,
    "avg_salary": 112500,
    "cor_product_dev": 0.3,
    "cor_gto_and_operational": 0.5,
    "cor_infrast_and_admin": 0.2,
    "pe_ratio": 12,
    "firm_cor": 0.57,
    "cor_product_dev_eff": 0.63,
    "cor_gto_and_operational_eff": 0.63,
    "cor_infrast_and_admin_eff": 0.63,
    "cogs_product_dev": 0.58,
    "cogs_gto_and_operational": 0.07,
    "cogs_infrast_and_admin": 0.2,
    "default_growth_rate": 2.49,
    "default_growth_adjustment": 0.53,
    "beginning_cash": beginning_cash[24],
    "investment_amount": beginning_cash[24], "market_size": 50000,
    "churn_rate": 0.075,
    "equity_stake_percentage": 0.1
  }
};

export const companyRenderFields = [
  { key: 'name', descriptor: 'Company Name', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Company name can only contain letters, numbers, and spaces.' },
  { key: 'industry', descriptor: 'Industry', inputType: 'select', options: industryOptions },
  { key: 'theme', descriptor: 'Theme', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Theme can only contain letters, numbers, and spaces.' },
  { key: 'details', descriptor: 'Details', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Details can only contain letters, numbers, spaces, commas, and periods.' },
  { key: 'in_currency', descriptor: 'Input Currency', inputType: 'select', options: currencyOptions },
  { key: 'out_currency', descriptor: 'Output Currency', inputType: 'select', options: currencyOptions },
  { key: 'years_to_ipo', descriptor: 'Years to IPO (Project Length)', inputType: 'number', regexCondition: /^(10|[1-9])$/, errorMessage: 'Years to IPO should be a number less than or equal to 10.', default: "1" },
];

export const capTableRenderFields = [
  { key: 'pe_ratio', descriptor: 'P/E Ratio', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'P/E Ratio should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
];

export const shareHoldersRenderFields = [
  { key: 'shareholder', descriptor: 'Shareholder Name', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Shareholder name can only contain letters, numbers, and spaces.' },
  { key: 'share_percentage', descriptor: 'Share Percentage %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Share percentage should be a number with up to 2 decimal places.', default: "0.00" }
]

export const investorSplitRenderFields = [
  { key: 'investor_name', descriptor: 'Investor Name', inputType: 'text', regexCondition: /^[a-zA-Z\s]*$/, errorMessage: 'Invalid investor name', default: '' },
  { key: 'split_percentage', descriptor: 'Investment Percentage %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Investment percentage should be a number with up to 2 decimal places.', default: "0.00" }
]

export const entityRenderFields = [
  { key: 'name', descriptor: 'Company Name', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Company name can only contain letters, numbers, and spaces.' },
  { key: 'industry', descriptor: 'Industry', inputType: 'select', options: industryOptions },
  { key: 'theme', descriptor: 'Theme', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Theme can only contain letters, numbers, and spaces.' },
  { key: 'details', descriptor: 'Details', inputType: 'text', regexCondition: /$|^[a-zA-Z0-9\s]+$/, errorMessage: 'Details can only contain letters, numbers, spaces, commas, and periods.' },
  { key: 'in_currency', descriptor: 'Input Currency', inputType: 'select', options: currencyOptions },
  { key: 'out_currency', descriptor: 'Output Currency', inputType: 'select', options: currencyOptions },
  { key: 'years_to_ipo', descriptor: 'Years to IPO (Project Length)', inputType: 'number', regexCondition: /^(10|[1-9])$/, errorMessage: 'Years to IPO should be a number less than or equal to 10.', default: "1" },
  { key: 'equity_stake_percentage', descriptor: 'Equity Stake %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Equity Stake % should be a number with up to 2 decimal places.', default: "0.00" },
];


export const otherVariablesCostRenderFields = [
  { key: 'labor_cost', descriptor: 'Labor Cost %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Labor cost should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
  { key: 'avg_salary', descriptor: 'Average Salary', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'Average salary should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
  { key: 'cross_selling_ars', descriptor: 'Cross Selling ARS %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Cross Selling ARS % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'contraction', descriptor: 'Contraction %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Contraction % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'pe_ratio', descriptor: 'P/E Ratio', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'P/E Ratio should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'investment_amount', descriptor: 'Investment Amount', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'Investment amount should be a number with up to 13 digits and 2 decimal places.', default: "0.00" }
]

export const psbbOtherVariablesRenderFields = otherVariablesCostRenderFields.slice(0, 4);

export const costAllocationsRenderFields = [
  { key: 'firm_cor', descriptor: 'Firm-wide CoR %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Firm-wide CoR % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cor_product_dev', descriptor: 'Product Development Cost', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'CoR % Product Dev. should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cor_product_dev_eff', descriptor: 'Cost Efficiency %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Cost Efficiency % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cor_gto_and_operational', descriptor: 'GTM and Operational Cost', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'CoR % Go-to-Market & Operational should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cor_gto_and_operational_eff', descriptor: 'Cost Efficiency %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Cost Efficiency % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cor_infrast_and_admin', descriptor: 'Infrastructure and Admin. Cost', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'CoR % Infrastructure should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cor_infrast_and_admin_eff', descriptor: 'Cost Efficiency %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Cost Efficiency % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cogs_product_dev', descriptor: 'COGS Weight %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'COGS Weight % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cogs_gto_and_operational', descriptor: 'COGS Weight %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'COGS Weight % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'cogs_infrast_and_admin', descriptor: 'COGS Weight %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'COGS Weight % should be a number with up to 2 decimal places.', default: "0.00" }
]

export const investmentEquityRenderFields = [
  { key: 'investment_amount', descriptor: 'Investment Amount', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'Investment amount should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
  { key: 'pricing_method', descriptor: 'Pricing Method', inputType: 'select', options: ['ROI', 'IRR'] },
  { key: 'investment_pricing_roi_multiplier', descriptor: 'Investment Pricing ROI Multiplier', inputType: 'number', regexCondition: /^(\d{0,4}(\.\d{0,4})?)?$/, errorMessage: 'Investment Pricing ROI Multiplier should be a number with up to 8 digits and 4 decimal places.', default: "0.0000" },
  { key: 'irr_percentage', descriptor: 'IRR %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'IRR % should be a number with up to 2 decimal places.', default: "0.0000" },
  { key: 'investor_share_percentage', descriptor: 'Investor Share %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Investor Share % should be a number with up to 2 decimal places.', default: "0.0000" },
  { key: 'equity_pricing_roi_multiplier', descriptor: 'Equity Pricing ROI Multiplier', inputType: 'number', regexCondition: /^(\d{0,4}(\.\d{0,4})?)?$/, errorMessage: 'Equity Pricing ROI Multiplier should be a number with up to 8 digits and 4 decimal places.', default: "0.0000" }
];

export const PSBBinvestmentEquityRenderFields = [
  { key: 'investment_amount', descriptor: 'Investment Amount', inputType: 'number', regexCondition: /^(\d{0,13}(\.\d{0,2})?)?$/, errorMessage: 'Investment amount should be a number with up to 13 digits and 2 decimal places.', default: "0.00" },
  { key: 'equity_stake_percentage', descriptor: 'Equity Stake %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Equity Stake % should be a number with up to 2 decimal places.', default: "0.00" },
  { key: 'pricing_method', descriptor: 'Pricing Method', inputType: 'select', options: ['ROI', 'IRR'] },
  { key: 'investment_pricing_roi_multiplier', descriptor: 'Investment Pricing ROI Multiplier', inputType: 'number', regexCondition: /^(\d{0,4}(\.\d{0,4})?)?$/, errorMessage: 'Investment Pricing ROI Multiplier should be a number with up to 8 digits and 4 decimal places.', default: "0.0000" },
  { key: 'irr_percentage', descriptor: 'IRR %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'IRR % should be a number with up to 2 decimal places.', default: "0.0000" },
  { key: 'investor_share_percentage', descriptor: 'Investor Share %', inputType: 'number', regexCondition: /^(\d{0,1}(\.\d{0,4})?)?$/, isPercent: true, errorMessage: 'Investor Share % should be a number with up to 2 decimal places.', default: "0.0000" },
  { key: 'equity_pricing_roi_multiplier', descriptor: 'Equity Pricing ROI Multiplier', inputType: 'number', regexCondition: /^(\d{0,4}(\.\d{0,4})?)?$/, errorMessage: 'Equity Pricing ROI Multiplier should be a number with up to 8 digits and 4 decimal places.', default: "0.0000" }
]
/*

*/

export const Template_Options = {
  "Big Number Card (KPIs)": {
    "keys": ["Valuation & Market Metrics", "Profitability & Financial Ratios", "Revenue & Growth", "Cost Structure & Efficiency", "Market & Customer Metrics", "Operational Metrics", "Investment Consideration"],
    "Valuation & Market Metrics": {
      "keys": ["Exit Valuation", "Pre-Money Valuation", "Revenue Multiplier", "VWAP (All Products)", "VWAP (Only Subscr.)"],
      "items": {
        "Exit Valuation": {
          "name": "Exit Valuation",
          "data_type": "Currency",
          "description": "The total market value of a company's shares at the time of its initial public offering."
        },
        "Pre-Money Valuation": {
          "name": "Pre-Money Valuation",
          "data_type": "Currency",
          "description": "The company's estimated value before receiving new investment or funding."
        },
        "Revenue Multiplier": {
          "name": "Revenue Multiplier",
          "data_type": "Ratio",
          "description": "A valuation metric comparing company value to its revenue."
        },
        "VWAP (All Products)": {
          "name": "VWAP (All Products)",
          "data_type": "Currency",
          "description": "Volume Weighted Average Price across all products sold."
        },
        "VWAP (Only Subscr.)": {
          "name": "VWAP (Only Subscr.)",
          "data_type": "Currency",
          "description": "Volume Weighted Average Price for subscription-based products only."
        }
      },
      "description": "Key valuation and market performance metrics."
    },
    "Profitability & Financial Ratios": {
      "keys": ["Net income (year specific)", "Net Profit Margin % (year specific)", "P/E Ratio", "Net Profit Margin %", "Customer Lifetime Return (LTV/CAC)"],
      "items": {
        "Net income (year specific)": {
          "name": "Net income (year specific)",
          "data_type": "Currency",
          "description": "The company's profit after all expenses (year specific).",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
            "wantedMetricName": "Net Income",    
          },
        },
        "Net Profit Margin % (year specific)": {
          "name": "Net Profit Margin % (year specific)",
          "data_type": "Percentage",
          "description": "Percentage of revenue left as profit after all expenses (year specific).",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
            "wantedMetricName": "Net Profit Margin %",    
          },
        },
        "P/E Ratio": {
          "name": "P/E Ratio",
          "data_type": "Ratio",
          "description": "Price-to-Earnings ratio; shows how much investors pay for each dollar of earnings."
        },
        "Net Profit Margin %": {
          "name": "Net Profit Margin %",
          "data_type": "Percentage",
          "description": "Percentage of revenue left as profit after all expenses."
        },
        "Customer Lifetime Return (LTV/CAC)": {
          "name": "Customer Lifetime Return (LTV/CAC)",
          "data_type": "Ratio",
          "description": "Ratio of customer lifetime value to acquisition cost; measures profitability per customer."
        }
      },
      "description": "Key profitability and financial health indicators."
    },
    "Revenue & Growth": {
      "keys": ["Total Revenue (year specific)", "Total Revenue Growth % (year specific)", "Total Revenue Growth %", "Set Revenue Growth %", "Firm Growth Scale %", "Ann. Rev p client / CAC", "Ave. Revenue Per Account (ARPA)"],
      "items": {
        "Total Revenue (year specific)": {
          "name": "Total Revenue (year specific)",
          "data_type": "Currency",
          "description": "All income generated from sales and services (year specific).",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
            "wantedMetricName": "Total Revenue",    
          },
        },
        "Total Revenue Growth % (year specific)": {
          "name": "Total Revenue Growth % (year specific)",
          "data_type": "Percentage",
          "description": "Percentage increase in total revenue for a specific year.",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
            "wantedMetricName": "Total Revenue Growth %",    
          },
        },
        "Total Revenue Growth %": {
          "name": "Total Revenue Growth %",
          "data_type": "Percentage",
          "description": "Firm wide percentage increase in total revenue."
        },
        "Set Revenue Growth %": {
          "name": "Set Revenue Growth %",
          "data_type": "Percentage",
          "description": "Base Revenue Growth"
        },
        "Firm Growth Scale %": {
          "name": "Firm Growth Scale %",
          "data_type": "Percentage",
          "description": "The rate of diminishing growth per sold units."
        },
        "Ann. Rev p client / CAC": {
          "name": "Ann. Rev p client / CAC",
          "data_type": "Ratio",
          "description": "Annual revenue per client divided by acquisition cost; efficiency measure."
        },
        "Ave. Revenue Per Account (ARPA)": {
          "name": "Ave. Revenue Per Account (ARPA)",
          "data_type": "Currency",
          "description": "Average revenue generated per customer account."
        }
      },
      "description": "Key revenue and growth performance metrics."
    },
    "Cost Structure & Efficiency": {
      "keys": ["Total Cost (year specific)", "Total Cost of Revenue % (year specific)", "Total Cost of Revenue %", "Fixed Cost %", "Variable Cost %", "Labor Cost of Revenue %", "Firm Cost Efficiency %", "Customer Acquisition Cost (CAC)"],
      "items": {
        "Total Cost (year specific)": {
          "name": "Total Cost (year specific)",
          "data_type": "Currency",
          "description": "All costs incurred from sales and services (year specific).",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
            "wantedMetricName": "Total Cost",    
          },
        },
        "Total Cost of Revenue % (year specific)": {
          "name": "Total Cost of Revenue % (year specific)",
          "data_type": "Percentage",
          "description": "Percentage of revenue spent to produce goods/services (year specific).",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
            "wantedMetricName": "Total Cost of Revenue %",    
          },
        },
        "Total Cost of Revenue %": {
          "name": "Total Cost of Revenue %",
          "data_type": "Percentage",
          "description": "Percentage of revenue spent to produce goods/services."
        },
        "Fixed Cost %": {
          "name": "Fixed Cost %",
          "data_type": "Percentage",
          "description": "Portion of costs that remain constant regardless of production volume."
        },
        "Variable Cost %": {
          "name": "Variable Cost %",
          "data_type": "Percentage",
          "description": "Portion of costs that change with production or sales volume."
        },
        "Labor Cost of Revenue %": {
          "name": "Labor Cost of Revenue %",
          "data_type": "Percentage",
          "description": "Share of revenue spent on labor costs."
        },
        "Firm Cost Efficiency %": {
          "name": "Firm Cost Efficiency %",
          "data_type": "Percentage",
          "description": "How effectively the company manages costs relative to output."
        },
        "Customer Acquisition Cost (CAC)": {
          "name": "Customer Acquisition Cost (CAC)",
          "data_type": "Currency",
          "description": "Average cost to acquire a new customer."
        }
      },
      "description": "Key cost structure and efficiency metrics."
    },
    "Market & Customer Metrics": {
      "keys": ["Total Market Share %", "Total Churn %", "Lifetime Value (LTV)"],
      "items": {
        "Total Market Share %": {
          "name": "Total Market Share %",
          "data_type": "Percentage",
          "description": "Company’s share of total market sales."
        },
        "Total Churn %": {
          "name": "Total Churn %",
          "data_type": "Percentage",
          "description": "Percentage of customers lost over a given period."
        },
        "Lifetime Value (LTV)": {
          "name": "Lifetime Value (LTV)",
          "data_type": "Currency",
          "description": "Total revenue expected from a customer during their relationship with the company."
        }
      },
      "description": "Key market presence and customer-related metrics."
    },
    "Operational Metrics": {
      "keys": ["Employees (Y5)", "Employees (Ave.)", "Runway (Months)"],
      "items": {
        "Employees (Y5)": {
          "name": "Employees (Y5)",
          "data_type": "Number",
          "description": "Number of employees projected or recorded in Year 5."
        },
        "Employees (Ave.)": {
          "name": "Employees (Ave.)",
          "data_type": "Number",
          "description": "Average number of employees over a period."
        },
        "Runway (Months)": {
          "name": "Runway (Months)",
          "data_type": "Number",
          "description": "How many months the company can operate before running out of cash."
        }
      },
      "description": "Key operational performance indicators."
    },
    "Investment Consideration": {
      "keys": ["Investor Equity %", "Investment Amount", "ROI%", "ROI Multiplier", "IRR%"],
      "items": {
        "Investor Equity %": {
          "name": "Investor Equity %",
          "data_type": "Percentage",
          "description": "Percentage of equity allocated to investors."
        },
        "Investment Amount": {
          "name": "Investment Amount",
          "data_type": "Currency",
          "description": "Total amount of investment."
        },
        "ROI%": {
          "name": "ROI%",
          "data_type": "Percentage",
          "description": "Return on Investment percentage."
        },
        "ROI Multiplier": {
          "name": "ROI Multiplier",
          "data_type": "Number",
          "description": "Multiplier used to calculate return based on investment."
        },
        "IRR%": {
          "name": "IRR%",
          "data_type": "Percentage",
          "description": "Internal Rate of Return percentage."
        }
      },
      "description": "Table for investment consideration."
    }
  },
  "Table (Firm Wide) KPIs": {
    "keys": [
      "Valuation & Market Metrics",
      "Profitability & Financial Ratios",
      "Revenue & Growth",
      "Cost Structure & Efficiency",
      "Market & Customer Metrics",
      "Operational Metrics"
    ],
    "Valuation & Market Metrics": {
      "keys": [
        "Exit Valuation",
        "Pre-Money Valuation",
        "Revenue Multiplier",
        "VWAP (All Products)",
        "VWAP (Only Subscr.)"
      ],
      "items": {
        "Exit Valuation": {
          "name": "Exit Valuation",
          "data_type": "Currency",
          "description": "The total market value of a company’s shares at the time of its initial public offering."
        },
        "Pre-Money Valuation": {
          "name": "Pre-Money Valuation",
          "data_type": "Currency",
          "description": "The company’s estimated value before receiving new investment or funding."
        },
        "Revenue Multiplier": {
          "name": "Revenue Multiplier",
          "data_type": "Ratio",
          "description": "A valuation metric comparing company value to its revenue."
        },
        "VWAP (All Products)": {
          "name": "VWAP (All Products)",
          "data_type": "Currency",
          "description": "Volume Weighted Average Price across all products sold."
        },
        "VWAP (Only Subscr.)": {
          "name": "VWAP (Only Subscr.)",
          "data_type": "Currency",
          "description": "Volume Weighted Average Price for subscription-based products only."
        }
      },
      "description": "Key valuation and market performance metrics."
    },
    "Profitability & Financial Ratios": {
      "keys": [
        "P/E Ratio",
        "Net Profit Margin %",
        "Customer Lifetime Return (LTV/CAC)"
      ],
      "items": {
        "P/E Ratio": {
          "name": "P/E Ratio",
          "data_type": "Ratio",
          "description": "Price-to-Earnings ratio; shows how much investors pay for each dollar of earnings."
        },
        "Net Profit Margin %": {
          "name": "Net Profit Margin %",
          "data_type": "Percentage",
          "description": "Percentage of revenue left as profit after all expenses."
        },
        "Customer Lifetime Return (LTV/CAC)": {
          "name": "Customer Lifetime Return (LTV/CAC)",
          "data_type": "Ratio",
          "description": "Ratio of customer lifetime value to acquisition cost; measures profitability per customer."
        }
      },
      "description": "Key profitability and financial health indicators."
    },
    "Revenue & Growth": {
      "keys": [
        "Total Revenue Growth %",
        "Set Revenue Growth %",
        "Firm Growth Scale %",
        "Ann. Rev p client / CAC",
        "Ave. Revenue Per Account (ARPA)"
      ],
      "items": {
        "Total Revenue Growth %": {
          "name": "Total Revenue Growth %",
          "data_type": "Percentage",
          "description": "Year-over-year percentage increase in total revenue."
        },
        "Set Revenue Growth %": {
          "name": "Set Revenue Growth %",
          "data_type": "Percentage",
          "description": "Base Revenue Growth"
        },
        "Firm Growth Scale %": {
          "name": "Firm Growth Scale %",
          "data_type": "Percentage",
          "description": "The rate of diminishing growth per sold units."
        },
        "Ann. Rev p client / CAC": {
          "name": "Ann. Rev p client / CAC",
          "data_type": "Ratio",
          "description": "Annual revenue per client divided by acquisition cost; efficiency measure."
        },
        "Ave. Revenue Per Account (ARPA)": {
          "name": "Ave. Revenue Per Account (ARPA)",
          "data_type": "Currency",
          "description": "Average revenue generated per customer account."
        }
      },
      "description": "Key revenue and growth performance metrics."
    },
    "Cost Structure & Efficiency": {
      "keys": [
        "Total Cost of Revenue %",
        "Fixed Cost %",
        "Variable Cost %",
        "Labor Cost of Revenue %",
        "Firm Cost Efficiency %",
        "Customer Acquisition Cost (CAC)"
      ],
      "items": {
        "Total Cost of Revenue %": {
          "name": "Total Cost of Revenue %",
          "data_type": "Percentage",
          "description": "Percentage of revenue spent to produce goods or services."
        },
        "Fixed Cost %": {
          "name": "Fixed Cost %",
          "data_type": "Percentage",
          "description": "Portion of costs that remain constant regardless of production volume."
        },
        "Variable Cost %": {
          "name": "Variable Cost %",
          "data_type": "Percentage",
          "description": "Portion of costs that change with production or sales volume."
        },
        "Labor Cost of Revenue %": {
          "name": "Labor Cost of Revenue %",
          "data_type": "Percentage",
          "description": "Share of revenue spent on labor costs."
        },
        "Firm Cost Efficiency %": {
          "name": "Firm Cost Efficiency %",
          "data_type": "Percentage",
          "description": "How effectively the company manages costs relative to output."
        },
        "Customer Acquisition Cost (CAC)": {
          "name": "Customer Acquisition Cost (CAC)",
          "data_type": "Currency",
          "description": "Average cost to acquire a new customer."
        }
      },
      "description": "Key cost structure and efficiency metrics."
    },
    "Market & Customer Metrics": {
      "keys": [
        "Total Market Share %",
        "Total Churn %",
        "Lifetime Value (LTV)"
      ],
      "items": {
        "Total Market Share %": {
          "name": "Total Market Share %",
          "data_type": "Percentage",
          "description": "Company’s share of total market sales."
        },
        "Total Churn %": {
          "name": "Total Churn %",
          "data_type": "Percentage",
          "description": "Percentage of customers lost over a given period."
        },
        "Lifetime Value (LTV)": {
          "name": "Lifetime Value (LTV)",
          "data_type": "Currency",
          "description": "Total revenue expected from a customer during their relationship with the company."
        }
      },
      "description": "Key market presence and customer-related metrics."
    },
    "Operational Metrics": {
      "keys": [
        "Employees (Y5)",
        "Employees (Ave.)",
        "Runway (Months)"
      ],
      "items": {
        "Employees (Y5)": {
          "name": "Employees (Y5)",
          "data_type": "Number",
          "description": "Number of employees projected or recorded in Year 5."
        },
        "Employees (Ave.)": {
          "name": "Employees (Ave.)",
          "data_type": "Number",
          "description": "Average number of employees over a period."
        },
        "Runway (Months)": {
          "name": "Runway (Months)",
          "data_type": "Number",
          "description": "How many months the company can operate before running out of cash."
        }
      },
      "description": "Key operational performance indicators."
    }
  },
  "Table (Projections)": {
    "keys": [
      "Revenue Metrics",
      "Cost Metrics",
      "Profitability Metrics",
      "Subscription & Unit Metrics",
      "Cash & Liquidity Metrics",
      "Customer Economics",
      "Workforce Metrics"
    ],
    "Revenue Metrics": {
      "keys": [
        "Total Revenue",
        "Revenue by Product (per product)",
        "Total Revenue Growth %",
        "Revenue Growth % (per product)",
        "Revenue Multiplier",
        "Revenue Function %",
        "Opening ARR",
        "New ARR",
        "Churn ARR",
        "Expansion/Cross-Sell",
        "Net New ARR",
        "Ending ARR",
        "Monthly Rec. Rev. (MRR)",
        "Annual Rev per Client"
      ],
      "items": {
        "Total Revenue": {
          "name": "Total Revenue",
          "data_type": "Currency",
          "description": "All income generated from sales and services."
        },
        "Revenue by Product (per product)": {
          "name": "Revenue by Product (per product)",
          "data_type": "Currency",
          "description": "Income broken down by individual product."
        },
        "Total Revenue Growth %": {
          "name": "Total Revenue Growth %",
          "data_type": "Percentage",
          "description": "Overall percentage increase in revenue over time."
        },
        "Revenue Growth % (per product)": {
          "name": "Revenue Growth % (per product)",
          "data_type": "Percentage",
          "description": "Growth rate for each product’s revenue."
        },
        "Revenue Multiplier": {
          "name": "Revenue Multiplier",
          "data_type": "Ratio",
          "description": "Ratio showing how revenue scales compared to a baseline."
        },
        "Revenue Function %": {
          "name": "Revenue Function %",
          "data_type": "Percentage",
          "description": "Revenue expressed as a percentage of a reference metric."
        },
        "Opening ARR": {
          "name": "Opening ARR",
          "data_type": "Currency",
          "description": "The total annual recurring revenue at the start of the reporting period."
        },
        "New ARR": {
          "name": "New ARR",
          "data_type": "Currency",
          "description": "ARR added from brand-new customers during the period."
        },
        "Churn ARR": {
          "name": "Churn ARR",
          "data_type": "Currency",
          "description": "ARR lost due to customer cancellations or non-renewals."
        },
        "Expansion/Cross-Sell": {
          "name": "Expansion/Cross-Sell",
          "data_type": "Currency",
          "description": "ARR growth from existing customers upgrading or purchasing additional products or services."
        },
        "Net New ARR": {
          "name": "Net New ARR",
          "data_type": "Currency",
          "description": "Net ARR change accounting for new sales, expansions, and churn."
        },
        "Ending ARR": {
          "name": "Ending ARR",
          "data_type": "Currency",
          "description": "Yearly subscription-based revenue at period end."
        },
        "Monthly Rec. Rev. (MRR)": {
          "name": "Monthly Rec. Rev. (MRR)",
          "data_type": "Currency",
          "description": "Monthly subscription-based revenue."
        },
        "Annual Rev per Client": {
          "name": "Annual Rev per Client",
          "data_type": "Currency",
          "description": "Average annual revenue per client or account."
        }
      },
      "description": "Key revenue and recurring revenue performance metrics."
    },
    "Cost Metrics": {
      "keys": [
        "Total Cost of Revenue %",
        "Product Development Cost",
        "Product Development Cost %",
        "GTM and Operational Cost",
        "GTM and Operational Cost %",
        "Infrastructure and Admin. Cost",
        "Infrastructure and Admin. Cost %",
        "Other Fixed Costs",
        "Other Fixed Costs %",
        "Fixed Cost",
        "Fixed Cost %",
        "Variable Cost",
        "Variable Cost %",
        "Total Cost",
        "Cost Function %",
        "Labor Cost",
        "Labor Cost of Rev. %"
      ],
      "items": {
        "Total Cost of Revenue %": {
          "name": "Total Cost of Revenue %",
          "data_type": "Percentage",
          "description": "Direct costs to produce and deliver products or services."
        },
        "Product Development Cost": {
          "name": "Product Development Cost",
          "data_type": "Currency",
          "description": "Expenses for creating and improving products."
        },
        "Product Development Cost %": {
          "name": "Product Development Cost %",
          "data_type": "Percentage",
          "description": "Product development cost as a percentage of total cost."
        },
        "GTM and Operational Cost": {
          "name": "GTM and Operational Cost",
          "data_type": "Currency",
          "description": "Marketing, sales, and operational expenses."
        },
        "GTM and Operational Cost %": {
          "name": "GTM and Operational Cost %",
          "data_type": "Percentage",
          "description": "Go-to-market and operational cost as a percentage of total cost."
        },
        "Infrastructure and Admin. Cost": {
          "name": "Infrastructure and Admin. Cost",
          "data_type": "Currency",
          "description": "Overhead costs for systems, facilities, and administration."
        },
        "Infrastructure and Admin. Cost %": {
          "name": "Infrastructure and Admin. Cost %",
          "data_type": "Percentage",
          "description": "Infrastructure and administrative cost as a percentage of total cost."
        },
        "Other Fixed Costs": {
          "name": "Other Fixed Costs",
          "data_type": "Currency",
          "description": "Non-variable costs not included elsewhere."
        },
        "Other Fixed Costs %": {
          "name": "Other Fixed Costs %",
          "data_type": "Percentage",
          "description": "Other fixed costs as a percentage of total cost."
        },
        "Fixed Cost": {
          "name": "Fixed Cost",
          "data_type": "Currency",
          "description": "All costs that remain constant regardless of volume."
        },
        "Fixed Cost %": {
          "name": "Fixed Cost %",
          "data_type": "Percentage",
          "description": "Total fixed cost as a percentage of total cost."
        },
        "Variable Cost": {
          "name": "Variable Cost",
          "data_type": "Currency",
          "description": "Costs that change with production or sales volume."
        },
        "Variable Cost %": {
          "name": "Variable Cost %",
          "data_type": "Percentage",
          "description": "Variable cost as a percentage of total cost."
        },
        "Total Cost": {
          "name": "Total Cost",
          "data_type": "Currency",
          "description": "All costs and expenses incurred."
        },
        "Cost Function %": {
          "name": "Cost Function %",
          "data_type": "Percentage",
          "description": "Total cost expressed as a percentage of revenue."
        },
        "Labor Cost": {
          "name": "Labor Cost",
          "data_type": "Currency",
          "description": "Employee-related expenses."
        },
        "Labor Cost of Rev. %": {
          "name": "Labor Cost of Rev. %",
          "data_type": "Percentage",
          "description": "Labor cost as a percentage of revenue."
        }
      },
      "description": "Detailed breakdown of company cost structure."
    },
    "Profitability Metrics": {
      "keys": [
        "Net Income",
        "P&L Function %",
        "Net Profit Margin %"
      ],
      "items": {
        "Net Income": {
          "name": "Net Income",
          "data_type": "Currency",
          "description": "Profit after all costs and expenses."
        },
        "P&L Function %": {
          "name": "P&L Function %",
          "data_type": "Percentage",
          "description": "Net income expressed as a percentage of revenue."
        },
        "Net Profit Margin %": {
          "name": "Net Profit Margin %",
          "data_type": "Percentage",
          "description": "Net income as a percentage of revenue."
        }
      },
      "description": "Key profitability and margin metrics."
    },
    "Subscription & Unit Metrics": {
      "keys": [
        "Product Units/Subscr. (per product)",
        "Ending subscr.",
        "Sales Targets Units / New Subscr. (per product)",
        "Total Unit/Subscr.",
        "Churn Subscr. (per product)",
        "Total Churn Subscr.",
        "Opening subscr.",
        "New subscr.",
        "Churn subscr.",
        "Expansion/Cross-sale",
        "Net new subscr."
      ],
      "items": {
        "Product Units/Subscr. (per product)": {
          "name": "Product Units/Subscr. (per product)",
          "data_type": "Number",
          "description": "Number of units or subscriptions per product."
        },
        "Ending subscr.": {
          "name": "Ending subscr.",
          "data_type": "Number",
          "description": "Total active subscriptions at period end."
        },
        "Sales Targets Units / New Subscr. (per product)": {
          "name": "Sales Targets Units / New Subscr. (per product)",
          "data_type": "Number",
          "description": "Planned new subscriptions per product."
        },
        "Total Unit/Subscr.": {
          "name": "Total Unit/Subscr.",
          "data_type": "Number",
          "description": "Total new subscribers across all products."
        },
        "Churn Subscr. (per product)": {
          "name": "Churn Subscr. (per product)",
          "data_type": "Number",
          "description": "Lost subscriptions per product."
        },
        "Total Churn Subscr.": {
          "name": "Total Churn Subscr.",
          "data_type": "Number",
          "description": "Total lost subscriptions across all products."
        },
        "Opening subscr.": {
          "name": "Opening subscr.",
          "data_type": "Number",
          "description": "Active subscriptions at the start of the period."
        },
        "New subscr.": {
          "name": "New subscr.",
          "data_type": "Number",
          "description": "Subscriptions added from new customers."
        },
        "Churn subscr.": {
          "name": "Churn subscr.",
          "data_type": "Number",
          "description": "Subscriptions lost due to cancellations or non-renewals."
        },
        "Expansion/Cross-sale": {
          "name": "Expansion/Cross-sale",
          "data_type": "Number",
          "description": "Additional subscriptions or upgrades from existing customers."
        },
        "Net new subscr.": {
          "name": "Net new subscr.",
          "data_type": "Number",
          "description": "Net change in subscriptions after churn and expansion."
        },
      },
      "description": "Subscription volume and unit-level performance metrics."
    },
    "Cash & Liquidity Metrics": {
      "keys": [
        "Cash Position",
        "Burn Rate Usage %",
        "Monthly Burn Rate"
      ],
      "items": {
        "Cash Position": {
          "name": "Cash Position",
          "data_type": "Currency",
          "description": "Available cash and liquid assets."
        },
        "Burn Rate Usage %": {
          "name": "Burn Rate Usage %",
          "data_type": "Percentage",
          "description": "Percentage of cash spent over time."
        },
        "Monthly Burn Rate": {
          "name": "Monthly Burn Rate",
          "data_type": "Currency",
          "description": "Monthly cash outflow rate."
        }
      },
      "description": "Liquidity, cash flow, and burn metrics."
    },
    "Customer Economics": {
      "keys": [
        "Customer Acquisition Cost (CAC)",
        "Ann. Rev p client / CAC",
        "Lifetime Value (LTV)",
        "Customer Lifetime Return (LTV/CAC)"
      ],
      "items": {
        "Customer Acquisition Cost (CAC)": {
          "name": "Customer Acquisition Cost (CAC)",
          "data_type": "Currency",
          "description": "Cost to acquire a new customer."
        },
        "Ann. Rev p client / CAC": {
          "name": "Ann. Rev p client / CAC",
          "data_type": "Ratio",
          "description": "Annual revenue per client compared to acquisition cost."
        },
        "Lifetime Value (LTV)": {
          "name": "Lifetime Value (LTV)",
          "data_type": "Currency",
          "description": "Total revenue expected from a customer over their lifetime."
        },
        "Customer Lifetime Return (LTV/CAC)": {
          "name": "Customer Lifetime Return (LTV/CAC)",
          "data_type": "Ratio",
          "description": "Ratio of customer lifetime value to acquisition cost."
        }
      },
      "description": "Customer unit economics and value metrics."
    },
    "Workforce Metrics": {
      "keys": ["Employees"],
      "items": {
        "Employees": {
          "name": "Employees",
          "data_type": "Number",
          "description": "Total number of staff."
        }
      },
      "description": "Workforce size and staffing metrics."
    }
  },
  "Product Analysis (KPIs)": {
    "keys": [],
    "description": "Key performance indicators focused on individual product performance."
  },
  "Pie Chart": {
    "keys": ["Cap Table %", "Cost Allocation %", "Revenue Allocation %"],
    "description": "Visual representation of data in pie chart format.",
    "Cap Table %": {
      "keys": ["Add"],
      "items": {
        "Add": {
          "name": "Cap Table %",
          "data_type": "Percentage",
          "description": "Add cap table pie chart."
        }
      },
      "description": "Cap Table is a snapshot of a company's ownership structure and how shares are allocated."
    },
    "Cost Allocation %": {
      "keys": ["Add"],
      "items": {
        "Add": {
          "name": "Cost Allocation %",
          "data_type": "Percentage",
          "description": "Add cost allocation pie chart."
        }
      },
      "description": "Cost allocation indicates how much of a shared expense is distributed to a particular cost center."
    },
    "Revenue Allocation %": {
      "keys": ["Add"],
      "items": {
        "Add": {
          "name": "Revenue Allocation %",
          "data_type": "Percentage",
          "description": "Add revenue allocation pie chart."
        }
      },
      "description": "Revenue allocation indicates how much of a shared revenue is distributed to a particular product."
    }
  },
  "Table (Pricing)": {
    "keys": ["Investment Consideration", "Price Your Share"],
    "Investment Consideration": {
      "keys": ["Investor Equity %", "Investment Amount", "ROI%", "ROI Multiplier", "IRR%"],
      "items": {
        "Investor Equity %": {
          "name": "Investor Equity %",
          "data_type": "Percentage",
          "description": "Percentage of equity allocated to investors."
        },
        "Investment Amount": {
          "name": "Investment Amount",
          "data_type": "Currency",
          "description": "Total amount of investment."
        },
        "ROI%": {
          "name": "ROI%",
          "data_type": "Percentage",
          "description": "Return on Investment percentage."
        },
        "ROI Multiplier": {
          "name": "ROI Multiplier",
          "data_type": "Number",
          "description": "Multiplier used to calculate return based on investment."
        },
        "IRR%": {
          "name": "IRR%",
          "data_type": "Percentage",
          "description": "Internal Rate of Return percentage."
        }
      },
      "description": "Table for investment consideration."
    },
    "Price Your Share": {
      "keys": ["Investor Share %", "ROI Multiplier", "Share Price (Amnt.)", "with ROI%", "IRR%"],
      "items": {
        "Investor Share %": {
          "name": "Investor Share %",
          "data_type": "Percentage",
          "description": "Percentage of shares owned by investors."
        },
        "ROI Multiplier": {
          "name": "ROI Multiplier",
          "data_type": "Number",
          "description": "Multiplier used to calculate return based on share price."
        },
        "Share Price (Amnt.)": {
          "name": "Share Price (Amnt.)",
          "data_type": "Currency",
          "description": "Monetary value of a single share."
        },
        "with ROI%": {
          "name": "with ROI%",
          "data_type": "Percentage",
          "description": "Return on Investment percentage associated with the share price."
        },
        "IRR%": {
          "name": "IRR%",
          "data_type": "Percentage",
          "description": "Internal Rate of Return percentage associated with the share price."
        }
      },
      "description": "Table for share pricing."
    }
  },
  "Chart (Projections)": {
    "keys": [
      "Revenue Metrics",
      "Cost Metrics",
      "Profitability Metrics",
      "Subscription & Unit Metrics",
      "Cash & Liquidity Metrics",
      "Customer Economics",
      "Workforce Metrics"
    ],
    "Revenue Metrics": {
      "keys": [
        "Total Revenue",
        "Revenue by Product (per product)",
        "Total Revenue Growth %",
        "Revenue Growth % (per product)",
        "Revenue Multiplier",
        "Revenue Function %",
        "Opening ARR",
        "New ARR",
        "Churn ARR",
        "Expansion/Cross-Sell",
        "Net New ARR",
        "Ending ARR",
        "Monthly Rec. Rev. (MRR)",
        "Annual Rev per Client"
      ],
      "items": {
        "Total Revenue": {
          "name": "Total Revenue",
          "data_type": "Currency",
          "description": "All income generated from sales and services."
        },
        "Revenue by Product (per product)": {
          "name": "Revenue by Product (per product)",
          "data_type": "Currency",
          "description": "Income broken down by individual product."
        },
        "Total Revenue Growth %": {
          "name": "Total Revenue Growth %",
          "data_type": "Percentage",
          "description": "Overall percentage increase in revenue over time."
        },
        "Revenue Growth % (per product)": {
          "name": "Revenue Growth % (per product)",
          "data_type": "Percentage",
          "description": "Growth rate for each product’s revenue."
        },
        "Revenue Multiplier": {
          "name": "Revenue Multiplier",
          "data_type": "Ratio",
          "description": "Ratio showing how revenue scales compared to a baseline."
        },
        "Revenue Function %": {
          "name": "Revenue Function %",
          "data_type": "Percentage",
          "description": "Revenue expressed as a percentage of a reference metric."
        },
        "Opening ARR": {
          "name": "Opening ARR",
          "data_type": "Currency",
          "description": "The total annual recurring revenue at the start of the reporting period."
        },
        "New ARR": {
          "name": "New ARR",
          "data_type": "Currency",
          "description": "ARR added from brand-new customers during the period."
        },
        "Churn ARR": {
          "name": "Churn ARR",
          "data_type": "Currency",
          "description": "ARR lost due to customer cancellations or non-renewals."
        },
        "Expansion/Cross-Sell": {
          "name": "Expansion/Cross-Sell",
          "data_type": "Currency",
          "description": "ARR growth from existing customers upgrading or purchasing additional products or services."
        },
        "Net New ARR": {
          "name": "Net New ARR",
          "data_type": "Currency",
          "description": "Net ARR change accounting for new sales, expansions, and churn."
        },
        "Ending ARR": {
          "name": "Ending ARR",
          "data_type": "Currency",
          "description": "Yearly subscription-based revenue at period end."
        },
        "Monthly Rec. Rev. (MRR)": {
          "name": "Monthly Rec. Rev. (MRR)",
          "data_type": "Currency",
          "description": "Monthly subscription-based revenue."
        },
        "Annual Rev per Client": {
          "name": "Annual Rev per Client",
          "data_type": "Currency",
          "description": "Average annual revenue per client or account."
        }
      },
      "description": "Key revenue and recurring revenue performance metrics."
    },
    "Cost Metrics": {
      "keys": [
        "Total Cost of Revenue %",
        "Product Development Cost",
        "Product Development Cost %",
        "GTM and Operational Cost",
        "GTM and Operational Cost %",
        "Infrastructure and Admin. Cost",
        "Infrastructure and Admin. Cost %",
        "Other Fixed Costs",
        "Other Fixed Costs %",
        "Fixed Cost",
        "Fixed Cost %",
        "Variable Cost",
        "Variable Cost %",
        "Total Cost",
        "Cost Function %",
        "Labor Cost",
        "Labor Cost of Rev. %"
      ],
      "items": {
        "Total Cost of Revenue %": {
          "name": "Total Cost of Revenue %",
          "data_type": "Percentage",
          "description": "Direct costs to produce and deliver products or services."
        },
        "Product Development Cost": {
          "name": "Product Development Cost",
          "data_type": "Currency",
          "description": "Expenses for creating and improving products."
        },
        "Product Development Cost %": {
          "name": "Product Development Cost %",
          "data_type": "Percentage",
          "description": "Product development cost as a percentage of total cost."
        },
        "GTM and Operational Cost": {
          "name": "GTM and Operational Cost",
          "data_type": "Currency",
          "description": "Marketing, sales, and operational expenses."
        },
        "GTM and Operational Cost %": {
          "name": "GTM and Operational Cost %",
          "data_type": "Percentage",
          "description": "Go-to-market and operational cost as a percentage of total cost."
        },
        "Infrastructure and Admin. Cost": {
          "name": "Infrastructure and Admin. Cost",
          "data_type": "Currency",
          "description": "Overhead costs for systems, facilities, and administration."
        },
        "Infrastructure and Admin. Cost %": {
          "name": "Infrastructure and Admin. Cost %",
          "data_type": "Percentage",
          "description": "Infrastructure and administrative cost as a percentage of total cost."
        },
        "Other Fixed Costs": {
          "name": "Other Fixed Costs",
          "data_type": "Currency",
          "description": "Non-variable costs not included elsewhere."
        },
        "Other Fixed Costs %": {
          "name": "Other Fixed Costs %",
          "data_type": "Percentage",
          "description": "Other fixed costs as a percentage of total cost."
        },
        "Fixed Cost": {
          "name": "Fixed Cost",
          "data_type": "Currency",
          "description": "All costs that remain constant regardless of volume."
        },
        "Fixed Cost %": {
          "name": "Fixed Cost %",
          "data_type": "Percentage",
          "description": "Total fixed cost as a percentage of total cost."
        },
        "Variable Cost": {
          "name": "Variable Cost",
          "data_type": "Currency",
          "description": "Costs that change with production or sales volume."
        },
        "Variable Cost %": {
          "name": "Variable Cost %",
          "data_type": "Percentage",
          "description": "Variable cost as a percentage of total cost."
        },
        "Total Cost": {
          "name": "Total Cost",
          "data_type": "Currency",
          "description": "All costs and expenses incurred."
        },
        "Cost Function %": {
          "name": "Cost Function %",
          "data_type": "Percentage",
          "description": "Total cost expressed as a percentage of revenue."
        },
        "Labor Cost": {
          "name": "Labor Cost",
          "data_type": "Currency",
          "description": "Employee-related expenses."
        },
        "Labor Cost of Rev. %": {
          "name": "Labor Cost of Rev. %",
          "data_type": "Percentage",
          "description": "Labor cost as a percentage of revenue."
        }
      },
      "description": "Detailed breakdown of company cost structure."
    },
    "Profitability Metrics": {
      "keys": [
        "Net Income",
        "P&L Function %",
        "Net Profit Margin %"
      ],
      "items": {
        "Net Income": {
          "name": "Net Income",
          "data_type": "Currency",
          "description": "Profit after all costs and expenses."
        },
        "P&L Function %": {
          "name": "P&L Function %",
          "data_type": "Percentage",
          "description": "Net income expressed as a percentage of revenue."
        },
        "Net Profit Margin %": {
          "name": "Net Profit Margin %",
          "data_type": "Percentage",
          "description": "Net income as a percentage of revenue."
        }
      },
      "description": "Key profitability and margin metrics."
    },
    "Subscription & Unit Metrics": {
      "keys": [
        "Product Units/Subscr. (per product)",
        "Ending subscr.",
        "Sales Targets Units / New Subscr. (per product)",
        "Total Unit/Subscr.",
        "Churn Subscr. (per product)",
        "Total Churn Subscr.",
        "Opening subscr.",
        "New subscr.",
        "Churn subscr.",
        "Expansion/Cross-sale",
        "Net new subscr."
      ],
      "items": {
        "Product Units/Subscr. (per product)": {
          "name": "Product Units/Subscr. (per product)",
          "data_type": "Number",
          "description": "Number of units or subscriptions per product."
        },
        "Ending subscr.": {
          "name": "Ending subscr.",
          "data_type": "Number",
          "description": "Total active subscriptions at period end."
        },
        "Sales Targets Units / New Subscr. (per product)": {
          "name": "Sales Targets Units / New Subscr. (per product)",
          "data_type": "Number",
          "description": "Planned new subscriptions per product."
        },
        "Total Unit/Subscr.": {
          "name": "Total Unit/Subscr.",
          "data_type": "Number",
          "description": "Total new subscribers across all products."
        },
        "Churn Subscr. (per product)": {
          "name": "Churn Subscr. (per product)",
          "data_type": "Number",
          "description": "Lost subscriptions per product."
        },
        "Total Churn Subscr.": {
          "name": "Total Churn Subscr.",
          "data_type": "Number",
          "description": "Total lost subscriptions across all products."
        },
        "Opening subscr.": {
          "name": "Opening subscr.",
          "data_type": "Number",
          "description": "Active subscriptions at the start of the period."
        },
        "New subscr.": {
          "name": "New subscr.",
          "data_type": "Number",
          "description": "Subscriptions added from new customers."
        },
        "Churn subscr.": {
          "name": "Churn subscr.",
          "data_type": "Number",
          "description": "Subscriptions lost due to cancellations or non-renewals."
        },
        "Expansion/Cross-sale": {
          "name": "Expansion/Cross-sale",
          "data_type": "Number",
          "description": "Additional subscriptions or upgrades from existing customers."
        },
        "Net new subscr.": {
          "name": "Net new subscr.",
          "data_type": "Number",
          "description": "Net change in subscriptions after churn and expansion."
        },
      },
      "description": "Subscription volume and unit-level performance metrics."
    },
    "Cash & Liquidity Metrics": {
      "keys": [
        "Cash Position",
        "Burn Rate Usage %",
        "Monthly Burn Rate"
      ],
      "items": {
        "Cash Position": {
          "name": "Cash Position",
          "data_type": "Currency",
          "description": "Available cash and liquid assets."
        },
        "Burn Rate Usage %": {
          "name": "Burn Rate Usage %",
          "data_type": "Percentage",
          "description": "Percentage of cash spent over time."
        },
        "Monthly Burn Rate": {
          "name": "Monthly Burn Rate",
          "data_type": "Currency",
          "description": "Monthly cash outflow rate."
        }
      },
      "description": "Liquidity, cash flow, and burn metrics."
    },
    "Customer Economics": {
      "keys": [
        "Customer Acquisition Cost (CAC)",
        "Ann. Rev p client / CAC",
        "Lifetime Value (LTV)",
        "Customer Lifetime Return (LTV/CAC)"
      ],
      "items": {
        "Customer Acquisition Cost (CAC)": {
          "name": "Customer Acquisition Cost (CAC)",
          "data_type": "Currency",
          "description": "Cost to acquire a new customer."
        },
        "Ann. Rev p client / CAC": {
          "name": "Ann. Rev p client / CAC",
          "data_type": "Ratio",
          "description": "Annual revenue per client compared to acquisition cost."
        },
        "Lifetime Value (LTV)": {
          "name": "Lifetime Value (LTV)",
          "data_type": "Currency",
          "description": "Total revenue expected from a customer over their lifetime."
        },
        "Customer Lifetime Return (LTV/CAC)": {
          "name": "Customer Lifetime Return (LTV/CAC)",
          "data_type": "Ratio",
          "description": "Ratio of customer lifetime value to acquisition cost."
        }
      },
      "description": "Customer unit economics and value metrics."
    },
    "Workforce Metrics": {
      "keys": ["Employees"],
      "items": {
        "Employees": {
          "name": "Employees",
          "data_type": "Number",
          "description": "Total number of staff."
        }
      },
      "description": "Workforce size and staffing metrics."
    }
  },
  "Miscellaneous": {
    "keys": ["Waterfall Charts", "Premade Tables"],
    "Waterfall Charts": {
      "keys": ["ARR Waterfall Chart", "ARS Waterfall Chart"],
      "items": {
        "ARR Waterfall Chart": {
          "name": "ARR Waterfall Chart",
          "data_type": "Waterfall Chart",
          "description": "Add ARR Waterfall Chart component.",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
          },
          "needed_data_type": "Currency",
          "needed": ["Opening ARR", "New ARR", "Expansion/Cross-Sell", "Churn ARR", "Contraction ARR", "Ending ARR"]
        },
        "ARS Waterfall Chart": {
          "name": "ARS Waterfall Chart",
          "data_type": "Waterfall Chart",
          "description": "Add ARS Waterfall Chart component.",
          "options": {
            "keys": ["year"],
            "year": {
              "value": "0",
              "name": "Year"
            },
          },
          "needed_data_type": "Number",
          "needed": ["Opening subscr.", "New subscr.", "Expansion/Cross-sale", "Churn subscr.", "Contraction ARS", "Ending subscr."]
        }
      },
      "description": "Waterfall charts visualize the cumulative effect of sequentially introduced positive or negative values.",
    },
    "Premade Tables": {
      "keys" : ["Cap Table"],
      "items": {
        "Cap Table": {
          "name": "Cap Table",
          "data_type": "Table",
          "description": "Add Cap Table component.",
          "options": {

          },
          "needed_data_type": "Currency"
        }
      }
    },
    "description": "Various other components and features."
  }
};

export const Template_Main_Keys = Object.keys(Template_Options);

export const Template_keys_description = {
  "Big Number Card (KPIs)": {
    description: "Display of key performance indicators in a big number card format.",
    type: "Big Number Card"
  },
  "Table (Firm Wide) KPIs": {
    description: "Comprehensive table of key performance indicators across various business dimensions.",
    type: "Table"
  },
  "Table (Projections)": {
    description: "Detailed table of projected financial and operational metrics.",
    type: "Table"
  },
  "Product Analysis (KPIs)": {
    description: "Key performance indicators focused on individual product performance.",
    type: "Table"
  },
  "Pie Chart": {
    description: "Visual representation of data in pie chart format.",
    type: "Pie Chart"
  },
  "Table (Pricing)": {
    description: "Table for investment consideration and share pricing.",
    type: "Table"
  },
  "Chart (Projections)": {
    description: "Graphical representation of projected financial and operational metrics.",
    type: "Chart"
  },
  "Miscellaneous": {
    description: "Various other components and features.",
    type: "Miscellaneous"
  }
};

export const productAnalysesKPIFields = {
  "keys": [
    "Pre-Money Valuation",
    "Mkt. Cap @ IPO Valuation (PV)",
    "Annual Rev per Client (ARPA)",
    "Customer Acquisition Cost (CAC)",
    "Ann. Rev p client / CAC",
    "Lifetime Value (LTV)",
    "Customer Lifetime Return (LTV/CAC)",
    "Product Growth %",
    "Product Profit Margin %"
  ],
  "items": {
    "Pre-Money Valuation": {
      "name": "Pre-Money Valuation",
      "data_type": "Currency",
      "description": "The company's estimated value before receiving new investment or funding.",
      "options": {
        "keys": ["year"],
        "year": {
          "value": "0",
          "name": "Year"
        },
      },
    },
    "Mkt. Cap @ IPO Valuation (PV)": {
      "name": "Mkt. Cap @ IPO Valuation (PV)",
      "data_type": "Currency",
      "description": "The total market value of a company's shares at the time of its initial public offering."
    },
    "Annual Rev per Client (ARPA)": {
      "name": "Annual Rev per Client (ARPA)",
      "data_type": "Currency",
      "description": "Average annual revenue per client or account."
    },
    "Customer Acquisition Cost (CAC)": {
      "name": "Customer Acquisition Cost (CAC)",
      "data_type": "Currency",
      "description": "Average cost to acquire a new customer."
    },
    "Ann. Rev p client / CAC": {
      "name": "Ann. Rev p client / CAC",
      "data_type": "Ratio",
      "description": "Annual revenue per client divided by acquisition cost; efficiency measure."
    },
    "Lifetime Value (LTV)": {
      "name": "Lifetime Value (LTV)",
      "data_type": "Currency",
      "description": "Total revenue expected from a customer during their relationship with the company."
    },
    "Customer Lifetime Return (LTV/CAC)": {
      "name": "Customer Lifetime Return (LTV/CAC)",
      "data_type": "Ratio",
      "description": "Ratio of customer lifetime value to acquisition cost; measures profitability per customer."
    },
    "Product Growth %": {
      "name": "Product Growth %",
      "data_type": "Percentage",
      "description": "Growth rate for a specific product."
    },
    "Product Profit Margin %": {
      "name": "Product Profit Margin %",
      "data_type": "Percentage",
      "description": "Percentage of revenue left as profit after all expenses for a specific product."
    }
  }
}

export const POSTrequestOptions = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'include',
};